<div class="w-full page-container bg-white rounded-lg p-4">
  <div class="border-b border-gray-200">
    <button
      (click)="toggle()"
      class="w-full text-left py-3 px-4 flex justify-between items-center focus:outline-none"
    >
      <span class="font-semibold text-lg">{{ question() }}</span>
      <fa-icon
        class="transition-transform duration-300"
        [icon]="faCaretDown"
        size="lg"
        [ngClass]="{ 'rotate-180': isOpen() }"
      ></fa-icon>
    </button>
    <div
      [class.open]="isOpen()"
      class="transition-height"
    >
      <div class="px-4 py-2">{{ answer() }}</div>
    </div>
  </div>
</div>
